import { render, staticRenderFns } from "./table.vue?vue&type=template&id=363b74c6"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('363b74c6')) {
      api.createRecord('363b74c6', component.options)
    } else {
      api.reload('363b74c6', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=363b74c6", function () {
      api.rerender('363b74c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/terminalRefund/components/table.vue"
export default component.exports